import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  AfterContentInit,
  ContentChildren,
  QueryList,
} from '@angular/core'

import { ButtonComponent } from '../button/button.component'
import {
  ButtonColorType,
  ButtonIconPositionType,
  ButtonSizeType,
  ButtonVariantType,
} from '../button/button.component.types'
import { IconValuesType } from '../icon/icon.component.types'
import { DropdownMenuComponent } from '../dropdown-menu'
import { DropdownMenuItemComponent } from '../dropdown-menu-item'

@Component({
  selector: 'hyperkit-button-menu',
  standalone: true,
  imports: [DropdownMenuComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './button-menu.component.html',
  styleUrls: ['./button-menu.component.scss'],
})
export class ButtonMenuComponent implements AfterContentInit {
  @Input() variant: ButtonVariantType = 'standard'
  @Input() color: ButtonColorType = 'primary'
  @Input() text = ''
  @Input() size: ButtonSizeType = 'medium'
  @Input() icon?: IconValuesType
  @Input() iconPosition: ButtonIconPositionType = 'left'
  @Input() disabled = false

  @Output() menuOpened = new EventEmitter<void>()
  @Output() menuClosed = new EventEmitter<void>()
  @Output() itemSelected = new EventEmitter<any>()

  @ContentChildren(DropdownMenuItemComponent)
  menuItems!: QueryList<DropdownMenuItemComponent>

  isMenuOpen = false

  ngAfterContentInit() {
    // Subscribe to all menu item clicks
    this.menuItems.forEach((item) => {
      item.itemClick.subscribe((event) => {
        this.itemSelected.emit(event)
        this.isMenuOpen = false
      })
    })

    // Re-subscribe when content changes
    this.menuItems.changes.subscribe(() => {
      this.menuItems.forEach((item) => {
        item.itemClick.subscribe((event: any) => {
          this.itemSelected.emit(event)
          this.isMenuOpen = false
        })
      })
    })
  }

  toggleMenu(event: Event) {
    event.stopPropagation()
    this.isMenuOpen = !this.isMenuOpen

    if (this.isMenuOpen) {
      this.menuOpened.emit()
    } else {
      this.menuClosed.emit()
    }
  }

  onMenuClosed() {
    this.isMenuOpen = false
    this.menuClosed.emit()
  }
}
